<template>
  <div data-test-id="CaseTabsComponent">
    <div class="tabs">
      <ul>
        <li :class="{ 'is-active': tab === 'complaints' }">
          <div class="nav-item tab-item" data-test-id="COMPLAINTS" @click="selectTab('complaints')">
            <b>COMPLAINTS</b>
          </div>
        </li>
        <li :class="{ 'is-active': tab === 'media' }">
          <div class="nav-item tab-item" data-test-id="MEDIA" @click="selectTab('media')">
            <b>MEDIA</b>
          </div>
        </li>
        <li :class="{ 'is-active': tab === 'chat' }">
          <div class="nav-item tab-item" data-test-id="CHAT" @click="selectTab('chat')">
            <b>CHAT</b>
          </div>
          <div v-show="unreadChatMessages > 0" class="chat-unread-messages">
            {{ unreadChatMessages }}
          </div>
        </li>
      </ul>
    </div>
    <div
      v-if="twiageCase.destinationHospital.nonTwiage"
      class="non-twiage-hospital-disclaimer"
      data-test-id="non-twiage-hospital-disclaimer"
    >
      Non-TigerConnect Hospital
      <br />
      No data will be sent to the hospital
    </div>
    <section class="tabs-details">
      <section v-show="tab === 'complaints'" data-test-id="COMPLAINTS-tab">
        <slot name="complaints"></slot>
      </section>
      <section v-show="tab === 'media'" data-test-id="MEDIA-tab">
        <slot name="media"></slot>
      </section>
      <section v-show="tab === 'chat'" data-test-id="CHAT-tab">
        <slot name="chat"></slot>
      </section>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CaseTabs",
  computed: {
    ...mapGetters("Case", {
      tab: "tab",
      twiageCase: "twiageCase",
    }),
    ...mapGetters("PubNubSubscription", ["unreadChatMessages"]),
  },
  methods: {
    ...mapActions("Case", {
      setTab: "setTab",
    }),
    selectTab(selectedTab) {
      this.setTab(selectedTab);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  background-color: rgb(191, 19, 17);
  padding: 1px;
  border-radius: 10px;
  margin-bottom: 5px;
}
.tabs-details {
  padding-top: 10px;
  padding-bottom: 10px;
  position: relative;
}
ul {
  display: flex;
  padding: 0;
  justify-content: space-between;
  list-style: none;
  margin: 0 auto;
  position: relative;
  background: #222;
  border-radius: 10px;

  li {
    text-align: center;
    padding: 10px;
    display: inline-block;
    width: 33%;
    &.is-active {
      background-color: rgb(191, 19, 17);
      border-radius: 10px;
    }
    .chat-unread-messages {
      position: absolute;
      top: -10px;
      right: -10px;
      background-color: #bf1311;
      padding: 5px;
      border-radius: 50%;
      width: 28px;
      font-size: 12px;
      font-weight: bold;
    }
  }
  .nav-item {
    cursor: pointer;
  }
}

.non-twiage-hospital-disclaimer {
  background-color: #f78024;
  color: black;
  margin: 8px 0;
  padding: 6px 0;
}
</style>
